export default "/assets/website/components/images/printer-circle.2f1bd6cb.svg";